import FloatUtility from './float.js';

export const floatUtility = new FloatUtility(window);
export default floatUtility;
